import React from "react";
import { Card as CardType } from "../types";
import { cardStyles } from "../styles";

interface CardProps {
  card: CardType;
  isSelected?: boolean;
  onClick?: () => void;
  compact?: boolean;
}

export const Card: React.FC<CardProps> = ({
  card,
  onClick,
  compact = false,
}) => {
  const baseStyle = compact ? cardStyles.cardCompact : cardStyles.cardBase;

  return (
    <div className={`${baseStyle} cursor-pointer`} onClick={onClick}>
      <div
        className={`flex items-center justify-center select-none h-full w-full`}
      >
        <div className="font-bold text-2xl text-black">{card.value}</div>
      </div>
    </div>
  );
};

export default Card;
